import { Form } from 'devextreme-react';
import {
  ButtonItem,
  ButtonOptions,
  GroupItem,
  Item,
  Label,
  RequiredRule,
} from 'devextreme-react/form';
import React, { useCallback, useRef } from 'react';
import { postApi } from '../../apiUtils';
import { useTranslation } from '../../contexts/translation';
import { API_URL } from '../../utils/apiUrl';

interface Props {
  entity: string;
  entityId: number;
  onSuccess: () => void;
}

export const HyperLinkForm = ({ entity, entityId, onSuccess }: Props) => {
  const { translate } = useTranslation();
  const transFormName = 'File';
  const formRef = useRef<any>();
  const formData = useRef<{ name: string; uri: string }>({ name: '', uri: '' });

  const onUpload = useCallback(async () => {
    await postApi({
      url: API_URL.HYPERLINK_CREATE,
      data: { ...formData.current, entity: entity, entityId },
      callAfterSuccess: () => {
        onSuccess();
        console.log('formRef', formRef);
        if (formRef && formRef.current && formRef.current.instance)
          formRef.current.instance.resetValues();
      },
    });
  }, [entity, entityId, formRef]);

  return (
    <form>
      <Form ref={formRef} formData={formData.current}>
        <GroupItem cssClass="form-group">
          <Item
            dataField={'name'}
            editorType={'dxTextBox'}
            editorOptions={{
              width: 300,
              placeholder: translate!('Enter name', transFormName),
            }}
          >
            <RequiredRule message={translate!('Name is required', transFormName)} />
            <Label text={translate!('Name', transFormName)} />
          </Item>
        </GroupItem>
        <GroupItem cssClass="form-group">
          <Item
            dataField={'uri'}
            editorType={'dxTextBox'}
            editorOptions={{
              width: 300,
              placeholder: translate!('Enter URL', transFormName),
            }}
          >
            <RequiredRule message={translate!('URL is required', transFormName)} />
            <Label text={translate!('URL', transFormName)} />
          </Item>
        </GroupItem>

        <GroupItem colCount={3}>
          <ButtonItem colSpan={2} verticalAlignment={'center'} horizontalAlignment={'left'}>
            <ButtonOptions
              text={translate!('Upload hyperlink', transFormName)}
              type={'success'}
              onClick={onUpload}
            />
          </ButtonItem>
        </GroupItem>
      </Form>
    </form>
  );
};
